import numeral from 'numeral';
import en from 'numeral/languages/en-gb';
import ru from 'numeral/languages/ru';

ru.abbreviations = en.abbreviations;

numeral.language('ru', ru);
numeral.language('ru');
